import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export enum ManagerAvailableModulesFields {
  BulletinBoard = '$BulletinBoard$',
  ProjectLinks = '$ProjectLinks$',
  AboutThisRoom = '$AboutThisRoom$',
  ModifyIndex = '$ManageIndex$',
  Countries = '$Countries$',
  DocumentTemplates = '$DocumentTemplates$',
  DocumentType = '$DocumentType$',
  EventManager = '$EventManager$',
  FAQ = '$FAQ$',
  FormSettings = '$FormSettings$',
  InvestigativeSites = '$InvestigativeSites$',
  IRB = '$IRB$',
  Organizations = '$Organizations$',
  QA = '$QA$',
  RecordType = '$RecordType$',
  RequiredDocuments = '$RequiredDocuments$',
  Tasks = '$Tasks$',
  Translations = '$Translations$',
}

class ManagerAvailableModulesConfig extends SettingsSubModule {
  @SettingsSubModule.value(ManagerAvailableModulesFields.BulletinBoard, false) bulletinBoard: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.ProjectLinks, false) projectLinks: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.AboutThisRoom, false) aboutThisRoom: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.ModifyIndex, false) modifyIndex: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.Countries, false) countries: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.DocumentTemplates, false)
  documentTemplates: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.DocumentType, false) documentType: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.EventManager, false) eventManager: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.FAQ, false) FAQ: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.FormSettings, false) formSettings: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.InvestigativeSites, false)
  investigativeSites: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.IRB, false) IRB: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.Organizations, false) organizations: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.QA, false) QA: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.RecordType, false) recordType: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.RequiredDocuments, false)
  requiredDocuments: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.Tasks, false) tasks: SettingValue<boolean>;
  @SettingsSubModule.value(ManagerAvailableModulesFields.Translations, false) translations: SettingValue<boolean>;
}

export class ManagerAvailableModulesModule extends SettingsModule {
  @SettingsModule.value(ManagerAvailableModulesConfig) managerAvailableModulesConfig: ManagerAvailableModulesConfig;
}
